async function initGoogleMap(elemID,latitude,longitude) {
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
  const map = new Map(document.getElementById(elemID), {
    center: { lat: latitude, lng: longitude },
    zoom: 14,
    mapId: "fc912b6b165abb2b",
  });
  console.log('WORKING HERE!',elemID,map)
  const marker = new AdvancedMarkerElement({
    map,
    position: { lat: latitude, lng: longitude },
  });
}